import React, { Fragment, useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { LayoutBar } from '../components/Layout';
import { ROUTE_INFOS, RouteInfo } from '../routes';
import { useRoutePermission } from '../hooks';

interface IProps {}

const AuthenticatedRoutes = (props: IProps) => {
  const { hasRoutePermission } = useRoutePermission();
  const navigate = useNavigate();

  const withPermission = (routeInfos: RouteInfo[]) =>
    routeInfos.filter(({ key }) => hasRoutePermission(key));

  const createRoutes = (routeInfos: RouteInfo[]): React.ReactElement => {
    return (
      <>
        {routeInfos.map((routeInfo: RouteInfo) => {
          const { key, route, element, children } = routeInfo;

          if (children && children.length > 0) {
            return createRoutes(withPermission(children));
          }

          return <Route key={key} path={route} element={element} />;
        })}
      </>
    );
  };

  const authorizedRoutes = createRoutes(withPermission(ROUTE_INFOS));

  // Auto Navigate to /transactionRequest
  useEffect(() => {
    navigate('/transactionRequest');
  }, []);

  return (
    <Routes>
      <Route path="/" element={<LayoutBar />}>
        {authorizedRoutes}
        <Route path="*" element={<Navigate replace to="/" />} />
      </Route>
    </Routes>
  );
};

export default AuthenticatedRoutes;
